import { DialogFooter, DialogHeader, DialogTitle } from '../../../../common/components/ui/dialog';
import { Button } from '../../../../common/components/ui/button';
import { abortUserInputForCart } from '../../actions/cartActions';
import { useTranslation } from 'react-i18next';
import { useCartErrorNotification } from '../../state-hooks/useCartErrorNotification';
import { toKeyedItems } from '../../../../common/utils/keyedItems';

export function CartDialogImportCsv() {
  const { t } = useTranslation();
  const { messages } = useCartErrorNotification();

  return (
    <>
      <DialogHeader>
        <DialogTitle className={'flex items-center'}>{t('CSV importieren')}</DialogTitle>
      </DialogHeader>
      <div>
        {messages && messages.length > 0 && (
          <ul>
            {toKeyedItems(messages).map(({ key, item: message }, index) => (
              <li key={key} className={index === 0 && messages.length > 1 ? 'font-bold' : ''}>
                {message}
              </li>
            ))}
          </ul>
        )}
      </div>
      <DialogFooter className={'flex-col desktop:flex-row gap-4 desktop:gap-1'}>
        <Button onClick={abortUserInputForCart} data-testid={'cart-ok-button'}>
          {t('OK')}
        </Button>
      </DialogFooter>
    </>
  );
}
